var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShiftAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 56,
    x: 7,
    y: 5,
    fill: "#cda1a7",
    rx: 2,
    ry: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 48,
    x: 31,
    y: -17,
    fill: "#deb4ba",
    rx: 1,
    ry: 1,
    transform: "rotate(-90 32 7)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#faefde",
    d: "M13 55L43 55 51 47 51 11 13 11 13 55z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bbdef9",
    d: "M43 47L51 47 43 55 43 47z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff7f0",
    d: "M51 35.47L51 14.63 17.57 54.88 33.88 54.88 51 35.47zM13.4 53.4L48.5 11 44 11 12.5 49.6 13.4 53.4zM13 43.42L39.5 11 38 11 13 41.53 13 43.42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.5 29L46.74 31.26 49 32.5 46.74 33.74 45.5 36 44.26 33.74 42 32.5 44.26 31.26 45.5 29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e3ae",
    d: "M42 6L32 1 22 6 21 13 43 13 42 6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.42 21L26.27 22.56 27.84 23.42 26.27 24.27 25.42 25.84 24.56 24.27 23 23.42 24.56 22.56 25.42 21zM22.65 48L23.23 49.06 24.3 49.65 23.23 50.23 22.65 51.3 22.07 50.23 21 49.65 22.07 49.06 22.65 48z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M32 4A2 2 0 1 0 32 8A2 2 0 1 0 32 4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M55,4H40.58L37.88,2A10,10,0,0,0,26.12,2L23.42,4H9A3,3,0,0,0,6,7V59a3,3,0,0,0,3,3H55a3,3,0,0,0,3-3V7A3,3,0,0,0,55,4ZM50,46H44a2,2,0,0,0-2,2v6H14V12h6.18A3,3,0,0,0,23,14H41a3,3,0,0,0,2.82-2H50Zm-1.41,2L44,52.59V48ZM27.29,3.66a8,8,0,0,1,9.41,0l4.06,3A3,3,0,0,1,42,9v2a1,1,0,0,1-1,1H23a1,1,0,0,1-1-1V9a3,3,0,0,1,1.24-2.43ZM56,59a1,1,0,0,1-1,1H9a1,1,0,0,1-1-1V7A1,1,0,0,1,9,6H21a5,5,0,0,0-1,3v1H14a2,2,0,0,0-2,2V54a2,2,0,0,0,2,2H42.17a3,3,0,0,0,2.12-.88l6.83-6.83A3,3,0,0,0,52,46.17V12a2,2,0,0,0-2-2H44V9a5,5,0,0,0-1-3H55a1,1,0,0,1,1,1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M18 17a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0zM22 20a1 1 0 0 0 1-1V17a1 1 0 0 0-2 0v2A1 1 0 0 0 22 20zM27 20a1 1 0 0 0 1-1V17a1 1 0 0 0-2 0v2A1 1 0 0 0 27 20zM32 20a1 1 0 0 0 1-1V17a1 1 0 0 0-2 0v2A1 1 0 0 0 32 20zM37 20a1 1 0 0 0 1-1V17a1 1 0 0 0-2 0v2A1 1 0 0 0 37 20zM42 20a1 1 0 0 0 1-1V17a1 1 0 0 0-2 0v2A1 1 0 0 0 42 20zM47 20a1 1 0 0 0 1-1V17a1 1 0 0 0-2 0v2A1 1 0 0 0 47 20zM32 4A2 2 0 1 0 32 8 2 2 0 1 0 32 4zM41 26a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2zM27 28H37a1 1 0 0 0 0-2H27a1 1 0 0 0 0 2zM27 32H39a1 1 0 0 0 0-2H27a1 1 0 0 0 0 2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#72caaf",
    d: "M39 40H27a1 1 0 0 0 0 2H39a1 1 0 0 0 0-2zM43 36H27a1 1 0 0 0 0 2H43a1 1 0 0 0 0-2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M22,26H20a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V28A2,2,0,0,0,22,26Zm-2.37,4.37V27.63h2.75v2.75Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#72caaf",
    d: "M22.29,36.29,20,38.59l-.29-.29a1,1,0,0,0-1.41,1.41l1,1a1,1,0,0,0,1.41,0l3-3a1,1,0,0,0-1.41-1.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftAudit);
export default __webpack_public_path__ + "static/media/ShiftAudit.672d239ae732c415c2c9803cad687458.svg";
export { ForwardRef as ReactComponent };